export default __webpack_public_path__ + "static/media/K2D-LightItalic.ed53f3d1.ttf";